import { combineReducers } from 'redux';
import auth from './auth';
import users from './users';
import content from './content';

export default combineReducers({
    auth,
    users,
    content,
});